

var bind = require('function-bind');
var $apply = require('./functionApply');
var actualApply = require('./actualApply');

/** @type {import('./applyBind')} */
module.exports = function applyBind() {
	return actualApply(bind, $apply, arguments);
};




//////////////////
// WEBPACK FOOTER
// ../node_modules/call-bind-apply-helpers/applyBind.js
// module id = ../node_modules/call-bind-apply-helpers/applyBind.js
// module chunks = 0